import CompetencyCourse from "@/components/training/CompetencyCourse";
import { decisionMakingCourse } from "@/data/longhandCompetencyCourses";

const DecisionMakingProcess = () => <CompetencyCourse course={decisionMakingCourse} />;

export default DecisionMakingProcess;
